function onDocumentReady(callback) {
    // Run this once the browser has finished building the page.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
        return;
    }

    callback();
}

function fadeOutElement(element, duration, callback) {
    // Fade an element out, then continue once the fade finishes.
    if (!element) {
        if (typeof callback === 'function') {
            callback();
        }
        return;
    }

    element.style.transition = 'opacity ' + duration + 'ms linear';
    element.style.opacity = '0';

    window.setTimeout(function() {
        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
}

function mountTemplateIfNeeded(templateSelector, mountSelector) {
    // Move a hidden template into the page the first time it is needed.
    if (document.querySelector(mountSelector)) {
        return;
    }

    var template = document.querySelector(templateSelector);
    if (!template || !template.content) {
        return;
    }

    document.body.appendChild(template.content.cloneNode(true));
}

function loadContactFormIfNeeded() {
    var slot = document.querySelector('[data-contact-form-slot]');

    // Only load the form once, and only if the contact drawer actually exists.
    if (!slot || slot.dataset.loaded === 'true' || slot.dataset.loading === 'true') {
        return;
    }

    var config = window.caTheme || {};
    // WordPress passes the AJAX details in from PHP.
    if (!config.ajaxUrl || !config.contactFormAction || !config.contactFormNonce) {
        slot.innerHTML = '<p class="contact-form-error">We could not load the form. Please email hello@creativeapproach.com.au.</p>';
        return;
    }

    // Ask WordPress for the form markup after the drawer is opened.
    slot.dataset.loading = 'true';

    var payload = new URLSearchParams({
        action: config.contactFormAction,
        nonce: config.contactFormNonce
    });

    fetch(config.ajaxUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        credentials: 'same-origin',
        body: payload.toString()
    })
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            if (!data || !data.success || !data.data || !data.data.markup) {
                slot.innerHTML = '<p class="contact-form-error">We could not load the form. Please email hello@creativeapproach.com.au.</p>';
                slot.dataset.loading = 'false';
                return;
            }

            slot.innerHTML = data.data.markup;
            slot.dataset.loaded = 'true';
            slot.dataset.loading = 'false';
        })
        .catch(function() {
            slot.innerHTML = '<p class="contact-form-error">We could not load the form. Please email hello@creativeapproach.com.au.</p>';
            slot.dataset.loading = 'false';
        });
}

function bindOverlayToggle(selector, bodyClass, wrapperSelector, onOpen) {
    var isAnimating = false;

    document.addEventListener('click', function(event) {
        var toggleElement = event.target.closest(selector);

        if (!toggleElement) {
            return;
        }

        event.preventDefault();

        // Stop double-clicks from opening and closing the panel too fast.
        if (isAnimating) {
            return;
        }

        var willOpen = !document.body.classList.contains(bodyClass);
        isAnimating = true;

        if (willOpen && typeof onOpen === 'function') {
            onOpen();
        }

        var wrapper = document.querySelector(wrapperSelector);
        if (!wrapper) {
            isAnimating = false;
            return;
        }

        var hasSettled = false;
        var settleAnimation = function() {
            if (hasSettled) {
                return;
            }

            hasSettled = true;
            isAnimating = false;
            wrapper.removeEventListener('transitionend', settleAnimation);
        };

        wrapper.addEventListener('transitionend', settleAnimation, {
            once: true
        });

        var applyState = function() {
            document.body.classList.toggle(bodyClass, willOpen);
        };

        if (willOpen) {
            window.requestAnimationFrame(function() {
                window.requestAnimationFrame(applyState);
            });
        } else {
            applyState();
        }

        window.setTimeout(settleAnimation, 700);
    });
}

onDocumentReady(function() {
    // Turn on code highlighting only when there is code on the page.
    if (window.hljs && document.querySelector('pre code')) {
        if (typeof window.hljs.highlightAll === 'function') {
            window.hljs.highlightAll();
        } else if (typeof window.hljs.initHighlightingOnLoad === 'function') {
            window.hljs.initHighlightingOnLoad();
        }
    }

    document.querySelectorAll('img[src$=".svg"], img[src$=".SVG"]').forEach(function(image) {
        // Give SVG images a class so they can be styled safely.
        image.classList.add('svg-image');
    });

    // Customer logo filter is loaded separately on pages that use it

    bindOverlayToggle('.slide-toggle', 'navigation-is-open', '.contact-pop-wrapper', function() {
        mountTemplateIfNeeded('#contact-pop-template', '#contact-pop');
        loadContactFormIfNeeded();
    });
    bindOverlayToggle('.menu-toggle', 'menu-is-open', '.menu-pop-wrapper', function() {
        mountTemplateIfNeeded('#menu-pop-template', '#menu-pop');
    });

    document.querySelectorAll('a.fade-out, .menu li a').forEach(function(link) {
        link.addEventListener('click', function(event) {
            var href = link.getAttribute('href') || '';

            // Leave in-page anchors and phone/email links alone.
            if (href === '' || href === '#' || href.charAt(0) === '#') {
                event.preventDefault();
                return;
            }

            if (
                link.getAttribute('target') === '_blank' ||
                href.indexOf('mailto:') === 0 ||
                href.indexOf('tel:') === 0
            ) {
                return;
            }

            event.preventDefault();
            var wrapper = document.querySelector('.outer-wrapper');

            fadeOutElement(wrapper, 400, function() {
                window.location.href = href;
            });
        });
    });

    if ((/iphone|ipod|ipad.*os 5/gi).test(window.navigator.appVersion)) {
        // Old iPhones can keep stale pages in memory, so refresh them.
        window.onpageshow = function(event) {
            if (event.persisted) {
                document.body.style.display = 'none';
                window.location.reload();
            }
        };
    }

    window.addEventListener('pageshow', function(event) {
        // Make sure the main content becomes visible again after navigation,
        // including when restored from the back/forward cache (persisted).
        var outerWrapper = document.querySelector('.outer-wrapper');
        if (outerWrapper) {
            // Clear any inline transition first so the reset is instant.
            outerWrapper.style.transition = 'none';
            outerWrapper.style.opacity = '1';
            outerWrapper.style.display = 'block';
        }

        if (event.persisted) {
            // Page restored from bfcache — ensure the load screen is also hidden.
            document.body.classList.remove('preload');
            var loadingWrapper = document.querySelector('.load-wrapper');
            if (loadingWrapper) {
                loadingWrapper.style.display = 'none';
            }
        }
    }, false);

    // Fade-in effects for any element marked with the WOW class.
    if (window.WOW && document.querySelector('.wow')) {
        var wow = new WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 10,
            mobile: false,
            live: true,
            callback: function() {},
            scrollContainer: null
        });
        wow.init();
    }

    window.addEventListener('scroll', function() {
        // Add a scrolled state once the page moves down a bit.
        var isScrolled = window.scrollY >= 60;
        document.querySelectorAll('.overlay').forEach(function(overlay) {
            overlay.classList.toggle('scrolling', isScrolled);
        });
    });

    // If the page was opened with #contact-pop, open the drawer immediately.
    if (window.location.hash === '#contact-pop') {
        document.body.classList.add('navigation-is-open');
        loadContactFormIfNeeded();
    }
});

window.addEventListener('load', function() {
    // Remove the loading screen after the page has fully finished loading.
    document.body.classList.remove('preload');

    var loadingWrapper = document.querySelector('.load-wrapper');
    fadeOutElement(loadingWrapper, 600, function() {
        if (loadingWrapper) {
            loadingWrapper.style.display = 'none';
        }
    });
});
